import { toEncodedClientDetails } from '@core/analytics/clientDetailsHeader';
import { toNowTimezoneString } from '@core/time/time';
import type { CreateWorkoutRequest } from '@engage/api-v2-models/generated/CreateWorkoutRequest';
import type { BaseAPI } from '../generated/core/request';
import { createWorkout } from '../generated/services/WorkoutsService';
import type { AnalyticsProps } from './spreadAnalytics';
import { spreadAnalytics } from './spreadAnalytics';

export const createWorkoutWithAnalytics = (
  api: BaseAPI,
  analyticsProps: AnalyticsProps,
  pelotonPlatform: Parameters<typeof createWorkout>[3],
  createWorkoutRequest: CreateWorkoutRequest,
  acceptLanguage?: string,
  options?: any,
) => {
  const encodedClientDetails = toEncodedClientDetails(spreadAnalytics(analyticsProps));

  return createWorkout(
    api,
    toNowTimezoneString(),
    createWorkoutRequest,
    pelotonPlatform,
    encodedClientDetails,
    acceptLanguage,
    options,
  );
};
